import * as React from 'react';
import {useEffect, useState} from 'react';
import Top from "../Top";
import Bottom from "../Bottom";
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import {styled} from '@mui/material/styles';
import Chip from '@mui/material/Chip';
import Divider from '@mui/material/Divider';
import {useLocation, useNavigate} from 'react-router-dom';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import img01 from "../../assets/images/img01.jpg";
import EventBusyIcon from '@mui/icons-material/EventBusy';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import api from "../../utils/api";
import * as util from "../../utils/util";
import axios from 'axios';

const ReservationView = () => {
  const navigate = useNavigate();
  const [open, setOpen] = React.useState(false);
  const handleClickOpen = (hoName: any, ipDate: any, rsvId: any, reservation: any) => {
    setSelectedHoName(hoName);
    setSelectedIpDate(ipDate);
    setSelectedReservationId(rsvId);
    setSelectedReservation(reservation);
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const [reservations, setReservations] = useState([]);
  const [selectedHoName, setSelectedHoName] = React.useState('');
  const [selectedIpDate, setSelectedIpDate] = React.useState('');
  const [selectedReservationId, setSelectedReservationId] = React.useState('');
  const [selectedReservation, setSelectedReservation] = React.useState({});
  /** 예약 취소 요청 중 — 응답 전에 다시 눌러 같은 취소가 두 번 나가지 않게 한다 */
  const [cancelBusy, setCancelBusy] = React.useState(false);
  /**
   * 결제 후 되돌아와 서버 반영을 기다리는 중인지.
   * 이때 '예약 정보가 없습니다' 를 그대로 보여주면, 방금 결제한 사용자가
   * 예약이 실패한 것으로 오해한다.
   */
  const [refreshing, setRefreshing] = React.useState(false);
  const { state } = useLocation();
  const isRefresh = state === null ? 'false' : util.strNull(state.isRefresh);
  
  const [reservationSelfList, setReservationSelfList] = useState([]);

  const [inspectionList, setInspectionList] = useState([]);
  const [counselList, setCounselList] = useState([]);
  const [allListCnt, setAllListCnt] = useState(0);
  
  useEffect(() => {
    // 예약 현황 목록 (접속자/접속자 가족 전부)
    getReservations();

    // 예약 후 redirect url 로 들어오는 경우 서버 반영까지 잠깐 재조회한다.
    // 이전에는 setInterval 을 정리하지도, 종료하지도 않아서 화면을 떠난 뒤에도
    // 초당 1회 호출이 영구히 계속되고 재진입할 때마다 타이머가 하나씩 늘어났다.
    if (util.strNull(isRefresh) !== 'true') return;

    setRefreshing(true);
    const MAX_RETRY = 10; // 최대 10초까지만 재조회
    let tries = 0;
    const timer = window.setInterval(() => {
      tries += 1;
      getReservations();
      if (tries >= MAX_RETRY) { window.clearInterval(timer); setRefreshing(false); }
    }, 1000);

    return () => { window.clearInterval(timer); setRefreshing(false); };
  }, []);
  
  function getReservations(){
    api.post('customer/api/v1/CU_004_001',{ cusId: window.localStorage.userCusID }).then((res:any) => {
      // setReservations(res.data.reverse());
      // const reservationData = res.data.inspection.concat(res.data.counsel);
      // setReservations(reservationData);

      // let tempSelfList: any = [];
      // let currentYear = new Date().getFullYear();
      // // 본인
      // for (let i = 0; i < reservationData.length; i++) {
      //   if (parseInt((reservationData[i].firstWishDate).substring(0, 4)) === currentYear) {
      //     tempSelfList.push(reservationData[i]);
      //   }
      // }

      // setReservationSelfList(tempSelfList);

      const nowYear = new Date().getFullYear().toString();

      // 건강검진
      setInspectionList(res.data.inspection.filter((v: any) => v.reservationStatus.code >= 0
          && util.strNull(v.ipDate) !== '' ? v.ipDate.startsWith(nowYear) : v.firstWishDate.startsWith(nowYear))); // 해당연도 && 예약대기, 예약확정, 수진완료, 결과등록 데이터만 출력

      // 심리상담
      setCounselList(res.data.counsel.filter((v: any) => v.reservationStatus.code >= 0
      && util.strNull(v.ipDate) !== '' ? v.ipDate.startsWith(nowYear) : v.firstWishDate.startsWith(nowYear)));

      // 총 갯수
      setAllListCnt(res.data.inspection.concat(res.data.counsel).filter((v: any) => v.reservationStatus.code >= 0
      && util.strNull(v.ipDate) !== '' ? v.ipDate.startsWith(nowYear) : v.firstWishDate.startsWith(nowYear)).length);

    }).catch(function (error:any) {
      console.log(error)
    });
  }
  
  // 예약 취소
  //
  // 예전에는 취소 성공 뒤 sendAT(알림톡) 이 끝나야 화면을 갱신했다. 그런데 sendAT 는
  // localStorage 값이 없으면 예외를 던졌고, 그 예외가 밖의 catch 로도 가지 않아
  // (반환하지 않는 promise 였다) **서버에서는 취소됐는데 화면은 그대로**였다.
  // 사용자는 취소가 안 된 줄 알고 다시 눌러 같은 요청을 반복했다.
  //
  // 알림톡은 부가 알림이므로 결과 표시를 막지 않게 분리하고, 목록은 화면이 이미 가진
  // getReservations() 로 다시 불러온다(문서 전체를 새로고침하던 window.location.replace 제거 —
  // 흰 화면이 번쩍이고 isAuth 등 진입 시 호출이 전부 다시 돌았다).
  function handleClickCancleReservation(){
    if (cancelBusy) return;            // 응답 오기 전 연타 방지
    setCancelBusy(true);
    api.post('customer/api/v1/CU_004_002', { rsvId: selectedReservationId })
      .then(() => {
        alert('예약이 취소되었습니다.');
        return sendAT(selectedReservation).catch((e: any) => console.log(e));
      })
      .catch(function (error: any) {
        console.log(error);
        alert('예약 취소 중 오류가 발생했습니다.\n잠시 후 다시 시도해 주세요.');
      })
      .finally(() => {
        setCancelBusy(false);
        setOpen(false);
        getReservations();
      });
  }
  
  // 예약 상태에 따른 문구
  function showStatus(reservation: any) {
    if (reservation.reservationStatus.name === '예약대기') {
      return (
        null
      )
    } else if (reservation.reservationStatus.name === '예약확정') {
      return (
        <Typography sx={{ fontSize: 14, color: '#c72a2a', mt: 1 }}>※ 예약일이 확정된 경우, 예약취소는 고객센터(1661-2645) 혹은 '문의' 버튼을 이용해 주세요.</Typography>
      )
    } else if (reservation.reservationStatus.name === '수검완료') {
      return (
        <Typography sx={{ fontSize: 14, color: '#c72a2a', mt: 1 }}>※ 수검완료 상태입니다. 취소가 불가합니다.</Typography>
      )
    } else if (reservation.reservationStatus.name === '결과등록') {
      return (
        <Typography sx={{ fontSize: 14, color: '#c72a2a', mt: 1 }}>※ 결과등록 상태입니다. 취소가 불가합니다.</Typography>
      )
    }
  }
  
  // 알림톡 관련 api
  const bizppurio = axios.create({
    baseURL: 'https://api.dualhealth.kr/nodes/bizppurio',
    timeout: 5000
  })

  // 알림톡 함수
  async function sendAT(sendItems: any) {

    // 예약 화면을 거쳐야 저장되는 값들이라, 로그인 직후에는 없는 것이 정상이다.
    // 예전에는 JSON.parse(... || '') 가 그 상황에서 SyntaxError 를 던졌고,
    // 그 예외 때문에 예약 취소 후 화면 갱신이 통째로 실행되지 않았다.
    const companyInfo = util.readStoredJson("companyInfo");
    const FAM_INFOS = util.readStoredJson("FAM_INFO");
    if (companyInfo === null || FAM_INFOS === null) {
      throw Error('알림톡 전송에 필요한 정보가 없습니다.');
    }

    const data = {
      type: companyInfo['type'],
      company_id: companyInfo['company_id'],
      company_name: companyInfo['company_name'],
      is_rebate_directly: companyInfo['is_rebate_directly'],
      rebate_price: companyInfo['rebate_price'],
      userName: FAM_INFOS['famName'],
      phone: FAM_INFOS['phone'],
      hospital_name: sendItems.hoName,
      package_name: sendItems.rsvName,
    }

    const info = {
      service: {
        "type": String(data.type ?? '').toLowerCase(),
        "target": String(data.company_id ?? '').includes("#") || String(data.company_id ?? '').toLowerCase() === "dualhealth" ? "customer" : String(data.company_id ?? '').toLowerCase(),
        "name": "건강검진"
      },
      "company": {
        "name": data.company_name,
        "isRebateDirectly": data.is_rebate_directly,
        "rebatePrice": data.rebate_price
      },
      "family": {
        "name": data.userName,
        "phone": String(data.phone ?? '').replaceAll(/[^\d]/ig, "")
      },
      "reservation": {
        "hospitalName": data.hospital_name,
        "packageName": data.package_name,
        // "firstWishDate": data.firstWishDate,
        // "secondWishDate": '-',
        // "confirmedDate": null,
        // "priceToPay": data.price
      }
    }
    const sendMSG = await bizppurio.post('/v1/message?msg=reservation_cancel', info).catch(e => alert("알림톡 전송에 실패했습니다."));
    return sendMSG;
  }


  
  return (
    <Container sx={{ bgcolor: '#F6F6F6', minHeight: '100vh', p: 0, pt: 7, pb: 12, minWidth: 320 }}>
      <Top title='예약 정보 확인' />

      <Box sx={{ bgcolor: '#FFFBF8' }}>
        <Typography sx={{ display: 'block', fontSize: '14px', color: '#444', fontWeight: 700, p: 0, pt: 3, pb: 0.5, textAlign: 'center' }}>
          예약일이 확정되면 취소가 되지 않습니다.
        </Typography>
        <Typography sx={{ display: 'block', fontSize: '14px', color: '#EF8322', fontWeight: 700, p: 0, pb: 3, textAlign: 'center' }}>
          확정 후 예약취소는 고객센터(1661-2645) 혹은 '문의' 버튼을 이용해 주세요.
        </Typography>
      </Box>

      {/* <Box sx={{ bgcolor: '#8949496b', mb: 2, position: 'absolute', left: 0, width: '100%', height: '280px' }}>
        <Typography sx={{
          fontSize: 30,
          fontWeight: 700,
          color: '#fff',
          transform: 'rotateZ(30deg)',
          textAlign: 'center',
          top: '40%',
          position: 'relative',
          border: '6px double #fff',
        }}>
          예약 취소</Typography>
      </Box> */}

      {/* 예약목록 */}
      
      
      
      {
        allListCnt < 1
          ? refreshing
            ? <Stack direction="column" justifyContent="center" alignItems="center" spacing={3} sx={{mt:10, }}>
                <Typography sx={{fontSize:16, color:'#888'}} >예약 정보를 불러오는 중입니다…</Typography>
              </Stack>
          : <Stack direction="column" justifyContent="center" alignItems="center" spacing={3} sx={{mt:10, }}>
              <EventBusyIcon sx={{fontSize:50, color:'#bbb'}} />
              <Typography sx={{fontSize:16, color:'#888'}} >예약 정보가 없습니다.</Typography>
              <Box sx={BtnStyle}>
                <Button variant="contained" sx={BottomBtnStyle} onClick={() => { navigate('../reservation') }}>
                  건강검진 예약하기
                </Button>
              </Box>
            </Stack>
          : null
      }

      {
        inspectionList.length > 0
          ? <Divider component="div" sx={{ mt: 5, mb: 3, fontSize: 14, color: '#777', width: '80%', ml: 'auto', mr: 'auto' }}><Chip label="건강검진" sx={{ width: 90 }} /></Divider>
          : null
      }

      {/* 건강검진 예약 현황 */}
      {
        inspectionList && inspectionList.map((reservation: any, index: any) => (
          <Box sx={{ p: 2, bgcolor: '#fff', my: 2 }}>
            
            {reservation.reservationStatus.code === -10 ? (
              <Box sx={{ bgcolor: '#8949496b', mb: 2, position: 'absolute', left: 0, width: '100%', height: '280px' }}>
                <Typography sx={{
                  fontSize: 30,
                  fontWeight: 700,
                  color: '#fff',
                  transform: 'rotateZ(30deg)',
                  textAlign: 'center',
                  top: '40%',
                  position: 'relative',
                  border: '6px double #fff',
                }}>
                  예약 취소</Typography>
              </Box>
            ) : (
              null
            )}
    
            <Stack direction="row" alignItems={'center'} spacing={0} sx={{ p: 0 }}>
              <Typography sx={{ fontSize: 16, ml: 1 }}>{util.strNull(reservation.ipDate) !== '' ? reservation.ipDate : reservation.firstWishDate}{reservation.reservationTime == '0' ? '' : ` ${String(reservation.reservationTime).slice(0, -2)}:${String(reservation.reservationTime).slice(-2)}`}
              <Typography component={'span'} sx={{ fontSize: 12, color: '#777', ml: 1 }}>{util.strNull(reservation.ipDate) !== '' ? '예약 확정일' : '예약 희망일'}</Typography> </Typography>
              <Button sx={{ fontSize: 12, ml: 'auto', p: 0, verticalAlign: 'baseline', color: '#888' }}
                onClick={() => { navigate('../reservation/SetFinishDetail', {state: {hoImage: reservation.hoImage, rsvId: reservation.rsvId, url: 'ReservationView'}}) }}>
                상세보기 <KeyboardArrowRightIcon sx={{ verticalAlign: 'top', color: '#999' }} />
              </Button>
            </Stack>
    
            <Card sx={{ borderRadius: 3, mt: 1 }}>
              {/*<BeenhereIcon sx={{ fontSize: 40, position: 'absolute', color: '#007e05de' }} /> 확정 시 */}
              <Stack direction="row" spacing={0} sx={{ p: 2, pt: 2, pb: 1 }}>
                <Typography sx={{ fontSize: 16, fontWeight: 700, mr:.5 }}>
                  {reservation.famName}
                </Typography>
                <Typography sx={{ fontSize: 14, }}>
                  {`(${reservation.famGrade})`}
                </Typography>
              </Stack>
              <Stack direction="row" justifyContent="center" alignItems="center" spacing={2} sx={{ p: 2, pt: 0, pb: 1 }}>
                <Box sx={{ width: 100, height: 80, display: 'flex', border:'1px solid #eee' }}>
                  <Img alt="care" src={util.strNull(reservation.hoImage) !== '' ? reservation.hoImage : img01} />
                </Box>
                <Stack direction="column" justifyContent="center" spacing={0} sx={{ width: '65%' }}>
                  <Typography sx={{ fontSize: 14, fontWeight: 700 }}>
                    {reservation.hoName}
                  </Typography>
                  <Typography sx={{ fontSize: 12, mt: 0.3, mb: 0.5 }}>
                    {reservation.hoAddress + reservation.hoBuildingNum}
                  </Typography>
                  <Typography sx={{ fontSize: 14, fontWeight: 700, }}>
                    {util.strNull(reservation.ipDate) !== '' ? reservation.ipDate : reservation.firstWishDate}
                    {reservation.reservationTime == '0' ? '' : ` ${String(reservation.reservationTime).slice(0, -2)}:${String(reservation.reservationTime).slice(-2)}`}
                    {reservation.reservationStatus.code <=0 ? (
                      <Chip label={reservation.reservationStatus.name} size="small" sx={{ ml: 1, verticalAlign: 'top', bgcolor:'#f18322', color:'#fff'  }}></Chip>
                    ) : (
                      <Chip label={reservation.reservationStatus.name} size="small" variant="outlined" sx={{ ml: 1, verticalAlign: 'top', color: '#f18322' }}></Chip>
                    )}
                  </Typography>
                </Stack>
              </Stack>
              <Stack direction="column" spacing={0} sx={{ p: 2, pt: 0 }}>
                <Typography sx={{ fontSize: 14, fontWeight: 700, mb: 0.5 }}>
                  {reservation.rsvName}
                </Typography>
                <Typography sx={{ fontSize: 14, }}>
                  {reservation.ipiList.join(', ')}
                </Typography>
              </Stack>
    
              <Divider />
    
              {/* <Box sx={{ flex: 3, textAlign: 'center', bgcolor: '#f18322', p: 1 }}>
                <Typography sx={{ fontWeight: 700, color: '#fff' }}>예약확정</Typography>
              </Box> */}
    
              {/* <Box sx={{ flex: 3, textAlign: 'center', bgcolor: '#d20000', p: 1 }}>
                <Typography sx={{ fontWeight: 700, color: '#fff' }}>예약취소</Typography>
              </Box> */}
              
              {reservation.reservationStatus.code === 0 ? (
                <Stack direction="row" justifyContent="center" alignItems="center" spacing={0} sx={{ bgcolor: '#f5f5f5', }}>
                  <Button sx={{ color: '#e33232', flex: 3, textAlign: 'center', p: 1, fontWeight:500 }} 
                    onClick={() => handleClickOpen(reservation.hoName, reservation.firstWishDate, reservation.rsvId, reservation)}>예약취소</Button>
                  <Divider orientation="vertical" variant="middle" flexItem />
                  <Button sx={{ color: '#555', flex: 1, textAlign: 'center', p: 1 }} onClick={() => { navigate('../Check/Counsel') }}>문의</Button>
                </Stack>
              ) : (
                <Stack direction="row" justifyContent="center" alignItems="center" spacing={0} sx={{ bgcolor: '#f5f5f5', }}>
                  <Box sx={{ color: '#aaa', flex: 3, textAlign: 'center', p: 1, fontSize: 14 }}>취소불가</Box>
                  <Divider orientation="vertical" variant="middle" flexItem />
                  <Button sx={{ color: '#555', flex: 1, textAlign: 'center', p: 1 }} onClick={() => { navigate('../Check/Counsel') }}>문의</Button>
                </Stack>
              )}
            </Card>
            
            {
              showStatus(reservation) // 예약 상태에 따른 문구
            }
          </Box>
        ))
      }

      {/* 심리상담 예약 현황 */}
      {
        counselList.length > 0
          ? <Divider component="div" sx={{ mt: 7, mb: 3, fontSize: 14, color: '#777', width: '80%', ml: 'auto', mr: 'auto' }}><Chip label="심리상담" sx={{ width: 90 }} /></Divider>
          : null
      }

      {
        counselList && counselList.map((reservation: any, index: any) => (
          <Box sx={{ p: 2, bgcolor: '#fff', my: 2 }}>
            
            {reservation.reservationStatus.code === -10 ? (
              <Box sx={{ bgcolor: '#8949496b', mb: 2, position: 'absolute', left: 0, width: '100%', height: '280px' }}>
                <Typography sx={{
                  fontSize: 30,
                  fontWeight: 700,
                  color: '#fff',
                  transform: 'rotateZ(30deg)',
                  textAlign: 'center',
                  top: '40%',
                  position: 'relative',
                  border: '6px double #fff',
                }}>
                  예약 취소</Typography>
              </Box>
            ) : (
              null
            )}
    
            <Stack direction="row" alignItems={'center'} spacing={0} sx={{ p: 0 }}>
              <Typography sx={{ fontSize: 16, ml: 1 }}>{util.strNull(reservation.ipDate) !== '' ? reservation.ipDate : reservation.firstWishDate}{reservation.reservationTime == '0' ? '' : ` ${String(reservation.reservationTime).slice(0, -2)}:${String(reservation.reservationTime).slice(-2)}`}
                <Typography component={'span'} sx={{ fontSize: 12, color: '#777', ml: 1 }}>{util.strNull(reservation.ipDate) !== '' ? '예약 확정일' : '예약 희망일'}
                <Chip label={`${reservation.count}차`} size="small" variant="outlined" sx={{ ml: 1,  border: '1px solid #f18322', color: '#f18322' }}></Chip>
                </Typography>
              </Typography>
              <Button sx={{ fontSize: 12, ml: 'auto', p: 0, verticalAlign: 'baseline', color: '#888' }}
                onClick={() => { navigate('../reservation/SetFinishDetail', {state: {hoImage: reservation.hoImage, rsvId: reservation.rsvId, url: 'ReservationView'}}) }}>
                상세보기 <KeyboardArrowRightIcon sx={{ verticalAlign: 'top', color: '#999' }} />
              </Button>
            </Stack>
    
            <Card sx={{ borderRadius: 3, mt: 1 }}>
              {/*<BeenhereIcon sx={{ fontSize: 40, position: 'absolute', color: '#007e05de' }} /> 확정 시 */}
              <Stack direction="row" spacing={0} sx={{ p: 2, pt: 2, pb: 1 }}>
                <Typography sx={{ fontSize: 16, fontWeight: 700, mr:.5 }}>
                  {reservation.famName}
                </Typography>
                <Typography sx={{ fontSize: 14, }}>
                  {`(${reservation.famGrade})`}
                </Typography>
              </Stack>
              <Stack direction="row" justifyContent="center" alignItems="center" spacing={2} sx={{ p: 2, pt: 0, pb: 1 }}>
                <Box sx={{ width: 100, height: 80, display: 'flex', border:'1px solid #eee' }}>
                  <Img alt="care" src={util.strNull(reservation.hoImage) !== '' ? reservation.hoImage : img01} />
                </Box>
                <Stack direction="column" justifyContent="center" spacing={0} sx={{ width: '65%' }}>
                  <Typography sx={{ fontSize: 14, fontWeight: 700 }}>
                    {reservation.hoName}
                  </Typography>
                  <Typography sx={{ fontSize: 12, mt: 0.3, mb: 0.5 }}>
                    {reservation.hoAddress + reservation.hoBuildingNum}
                  </Typography>
                  <Typography sx={{ fontSize: 14, fontWeight: 700, }}>
                    {util.strNull(reservation.ipDate) !== '' ? reservation.ipDate : reservation.firstWishDate}
                    {reservation.reservationTime == '0' ? '' : ` ${String(reservation.reservationTime).slice(0, -2)}:${String(reservation.reservationTime).slice(-2)}`}
                    {reservation.reservationStatus.code <=0 ? (
                      <Chip label={reservation.reservationStatus.name} size="small" sx={{ ml: 1, verticalAlign: 'top', bgcolor:'#f18322', color:'#fff'  }}></Chip>
                    ) : (
                      <Chip label={reservation.reservationStatus.name} size="small" variant="outlined" sx={{ ml: 1, verticalAlign: 'top', color: '#f18322' }}></Chip>
                    )}
                  </Typography>
                </Stack>
              </Stack>
              <Stack direction="column" spacing={0} sx={{ p: 2, pt: 0 }}>
                <Typography sx={{ fontSize: 14, fontWeight: 700, mb: 0.5 }}>
                  {reservation.rsvName}
                </Typography>
                <Typography sx={{ fontSize: 14, }}>
                  {reservation.ipiList.join(', ')}
                </Typography>
              </Stack>
    
              <Divider />
    
              {/* <Box sx={{ flex: 3, textAlign: 'center', bgcolor: '#f18322', p: 1 }}>
                <Typography sx={{ fontWeight: 700, color: '#fff' }}>예약확정</Typography>
              </Box> */}
    
              {/* <Box sx={{ flex: 3, textAlign: 'center', bgcolor: '#d20000', p: 1 }}>
                <Typography sx={{ fontWeight: 700, color: '#fff' }}>예약취소</Typography>
              </Box> */}
              
              {reservation.reservationStatus.code === 0 ? (
                <Stack direction="row" justifyContent="center" alignItems="center" spacing={0} sx={{ bgcolor: '#f5f5f5', }}>
                  <Button sx={{ color: '#e33232', flex: 3, textAlign: 'center', p: 1, fontWeight:500 }} 
                    onClick={() => handleClickOpen(reservation.hoName, reservation.firstWishDate, reservation.rsvId, reservation)}>예약취소</Button>
                  <Divider orientation="vertical" variant="middle" flexItem />
                  <Button sx={{ color: '#555', flex: 1, textAlign: 'center', p: 1 }} onClick={() => { navigate('../Check/Counsel') }}>문의</Button>
                </Stack>
              ) : (
                <Stack direction="row" justifyContent="center" alignItems="center" spacing={0} sx={{ bgcolor: '#f5f5f5', }}>
                  <Box sx={{ color: '#aaa', flex: 3, textAlign: 'center', p: 1, fontSize: 14 }}>취소불가</Box>
                  <Divider orientation="vertical" variant="middle" flexItem />
                  <Button sx={{ color: '#555', flex: 1, textAlign: 'center', p: 1 }} onClick={() => { navigate('../Check/Counsel') }}>문의</Button>
                </Stack>
              )}
            </Card>
            
            {
              showStatus(reservation) // 예약 상태에 따른 문구
            }
          </Box>
        ))
      }

      <Dialog
        open={open}
        onClose={handleClose}
        sx={{ '& .MuiDialog-paper': { borderRadius: 4 } }}
      >
        {/* <DialogTitle sx={{ fontSize: 18, fontWeight: 700, textAlign:'center' }}>
          예약을 취소하시나요?
        </DialogTitle> */}
        {/* <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
          }}
        >
          <CloseIcon />
        </IconButton> */}
        <DialogContent dividers sx={{p:4}}>
          <DialogContentText id="alert-dialog-description">
            <Stack direction="column" justifyContent="center" alignItems={'center'} spacing={0} sx={{}}>
              <EventBusyIcon sx={{ fontSize: 50, color: '#bbb', mb: 1, mt: 1 }} />
              <Typography sx={{ fontSize: 16, fontWeight: 700 }}>
                {selectedHoName}
              </Typography>
              <Typography sx={{ fontSize: 16, fontWeight: 700, m: 1, mb: 2 }}>
                {selectedIpDate}
              </Typography>
              <Typography sx={{ fontSize: 16, fontWeight: 700, color: '#ff5555', mb: 1 }}>
                예약을 취소하시겠습니까?
              </Typography>
            </Stack>
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'center', '&.MuiDialogActions-root': { p: 0, } }}>

          <Button onClick={handleClose} sx={{ flex: 1, bgcolor: '#f0f0f0', p: 1, borderRadius: 0, color: '#444' }}>
            닫기
          </Button>
          {/* <Divider orientation="vertical" variant="fullWidth" flexItem /> */}
          <Button onClick={handleClickCancleReservation} sx={{ flex: 1, bgcolor: '#ef8322', p: 1, borderRadius: 0, m: '0 !important', color: '#fff', fontWeight: 700, }}>
            취소하기
          </Button>

        </DialogActions>
      </Dialog>

      <Bottom />
    </Container >
  );
}

const Img = styled('img')({
  margin: 'auto',
  display: 'block',
  maxWidth: '100%',
  maxHeight: '100%',
});

const BtnStyle = {
  display: 'flex',
  justifyContent: 'center',
  m: '3 0',
  mt: 8,
  boxSizing: 'border-box',
  width: '80%',
};

const BottomBtnStyle = {
  width: '100%',
  bgcolor: '#EF8322',
  fontSize: 18,
  fontWeight: 700,
  borderRadius: '30px', p: 1,
  boxSizing: 'border-box',
  color: '#fff',
  border: '1px solid #ef8322',
  ':hover': {
    backgroundColor: '#EF8322',
    borderColor: '#EF8322',
    boxShadow: 'none',
    color: '#fff'
  },
  ':active': {
    boxShadow: 'none',
    backgroundColor: '#EF8322',
    borderColor: '#EF8322',
  },
  ':focus': {
    boxShadow: 'none',
  },
};

export default ReservationView;